/**
 * Interfeys lug'ati: o'zbek (lotin). O'z
 * Kalitlar ru.js bilan mos bo'lishi kerak. APIga kanonik qiymatlar yuboriladi.
 */
export default {
  header_filters: 'Filtrlar',
  header_done: "Qo'llash",
  filters_close: 'Filtrlarni yopish',
  header_city_title: 'Shaharni tanlang',
  header_language: 'Til',
  header_outreach: 'Tarqatma',
  header_outreach_title: 'Telegram tarqatma dashbordi',
  header_debug: 'Debug',
  header_debug_title: "Xarita debug rejimi (manzildagi ?debug= kabi): geokodlash ma'lumotlari, avvalgi koordinatalar va yashirilgan eʼlonlar",
  loading: 'Filtrlar yuklanmoqda…',

  placeholder_min: 'min',
  placeholder_max: 'maks',
  common_any_value: 'Har qanday',
  common_yes: 'Ha',
  common_no: 'Yo\'q',
  common_any_type: 'Har qanday turi',
  common_any_type_plot: 'Har qanday uchastka turi',
  common_any_type_house: 'Har qanday uy turi',
  common_any_layout: 'Har qanday reja',
  common_any_bathroom: 'Har qanday hojatxona',
  common_any_renovation: 'Har qanday ta\'mir',
  common_gas_any: 'Gazli va gazsiz',
  common_any_heating: 'Har qanday isitish',
  common_any_purpose: 'Har qanday maqsad',
  common_any_location: 'Har qanday joylashuv',
  common_any_finishing: 'Har qanday bitimi',
  common_any_facade: 'Har qanday fasad',
  common_any_parking: 'Har qanday parkovka',
  common_any_stage: 'Har qanday bosqich',
  common_any_class: 'Har qanday sinf',

  filters_price: 'Narx',
  filters_commission_up_to: 'Komissiya hadgacha',
  filters_rooms: 'Xonalar soni',
  filters_area_total: 'Umumiy maydon, m²',
  filters_area_living: 'Yashash maydoni, m²',
  filters_area_kitchen: 'Oshxona maydoni, m²',
  filters_area_usable: 'Foydalanish maydoni, m²',
  filters_plot_area: 'Uchastka maydoni, sotix',
  filters_floor: 'Qavat',
  filters_floors_total: 'Bino qavatlari',
  filters_ceiling: 'Shift balandligi, m',
  filters_year_built: 'Qurilish yili',
  filters_housing_type: 'Uy-joy turi',
  filters_building_type: 'Qurilish turi',
  filters_layout: 'Reja',
  filters_bathroom: 'Hojatxona',
  filters_furnished: 'Mebel bilan',
  filters_renovation: 'Ta\'mir',
  filters_gas: 'Gaz',
  filters_features_inside: 'Kvartirada bor',
  filters_features_inside_commercial: 'Joyda bor',
  filters_features_nearby: 'Yaqinda bor',
  filters_plot_features: 'Uyda / uchastkada bor',
  filters_house_conditions: 'Uy holati',
  filters_water: 'Suv',
  filters_heating: 'Isitish',
  filters_communications: 'Aloqa',
  filters_realty_type: 'Ko\'chmas mulk turi',
  filters_house_location: 'Joylashuv',
  filters_land_purpose: 'Maqsad',
  filters_plot_type: 'Uchastka turi',
  filters_garage_type: 'Tur',
  filters_garage_purpose: 'Maqsad',
  filters_commercial_location: 'Joylashuv',
  filters_commercial_has_plot: 'Uchastka',
  filters_electricity: 'Elektrik',
  filters_has_parking: 'Parkovka',
  filters_house_type: 'Uy turi',
  filters_housing_class: 'Uy-joy sinfi',
  filters_blocks_count: 'Korpuslar soni',
  filters_finishing: 'Bitimi',
  filters_facade: 'Fasad',
  filters_parking_type: 'Parkovka',
  filters_construction_stage: 'Qurilish bosqichi',
  filters_parking_slots_from: 'Mashina joylari soni',
  filters_installment: 'Muddatli to\'lov',
  filters_mortgage: 'Ipoteka',

  balloon_no_photo: 'Rasm yo\'q',
  carousel_prev: 'Oldingi',
  carousel_next: 'Keyingi',
  debug_section_title: 'Debug ma\'lumotlar',
  debug_description: 'Tavsif',
  debug_geocoded_by: 'Geokod manbasi',
  debug_geocoded: 'Geocoded',
  debug_landmarks_anomalies: 'Landmarks anomalies',
  debug_landmarks_approved: 'Landmarks approved',
  debug_geocoding_requests: 'Geocoding requests',
  debug_change_link: "Lokatsiyani o'zgartirish uchun shaxsiy havola",
  debug_regeocode_button: 'Regeocode',
  debug_regeocode_status_running: 'Qayta geokodlash...',
  debug_regeocode_status_done: "Tayyor: geoma'lumot yangilandi",
  debug_regeocode_status_error: 'Qayta geokodlash xatosi',
  debug_regeocode_status_unchanged: "Koordinatalar o'zgarmadi",
  debug_regeocode_flash_unchanged: "Koordinatalar o'zgarmadi",
  debug_toggle_on: 'Debug rejimi yoqildi',
  debug_toggle_off: "Debug rejimi o'chirildi",

  // Lokatsiyani o'zgartirish rejimi (?change=...)
  change_button: "Lokatsiyani o'zgartirish",
  change_pick_hint: 'Yangi lokatsiyani tanlash uchun xaritani bosing',
  change_cancel: 'Bekor qilish',
  change_confirm_title: 'Yangi lokatsiya saqlansinmi?',
  change_confirm_hint: 'Nuqtani aniqlashtirish uchun surib bo\'ladi',
  change_confirm: 'Tasdiqlash',
  change_saving: 'Saqlanmoqda...',
  change_save_done: 'Lokatsiya yangilandi',
  change_save_error: 'Lokatsiyani saqlab bo\'lmadi',
  change_hide_button: 'Yashirish',
  change_show_button: "Ko'rsatish",
  change_hide_confirm_title: 'Eʼlon yashirilsinmi?',
  change_show_confirm_title: 'Eʼlon koʻrsatilsinmi?',
  change_hide_confirm_hint: 'Eʼlon oddiy foydalanuvchilarga xaritada koʻrinmay qoladi',
  change_show_confirm_hint: 'Eʼlon yana hammaga koʻrinadi',
  change_hide_done: 'Eʼlon yashirildi',
  change_show_done: 'Eʼlon koʻrsatildi',
  change_hide_error: 'Koʻrinishni oʻzgartirib boʻlmadi',
  balloon_hidden_banner: 'Eʼlon yashirilgan',

  // Bir martalik havola orqali avtorizatsiya
  auth_menu_title: 'Profil',
  auth_logout: 'Chiqish',
  auth_login_success: "Tizimga kirdingiz — e'lonlaringiz to'q sariq rangda ajratilgan. Lokatsiyani o'zgartirish yoki yashirish uchun o'z e'loningizni oching",
  auth_login_success_no_hide: "Tizimga kirdingiz — e'lonlaringiz to'q sariq rangda ajratilgan. Lokatsiyani o'zgartirish uchun o'z e'loningizni oching",
  auth_login_error: 'Kirish havolasi yaroqsiz yoki eskirgan',
  auth_logged_out: 'Tizimdan chiqdingiz',

  // Muallifning o'z e'lonini tahrirlashi (shaxsiy login-havola orqali kirish)
  author_card_hint: "Bu sizning e'loningiz: lokatsiyani o'zgartirish yoki xaritadan yashirish mumkin",
  author_card_hint_no_hide: "Bu sizning e'loningiz: lokatsiyani o'zgartirish mumkin",
  author_save_done: "Rahmat! E'loningiz lokatsiyasi yangilandi",
  author_hide_done: "E'lon xaritadan yashirildi. «Ko'rsatish» tugmasi orqali qaytarish mumkin",
  author_session_expired: "Saqlab bo'lmadi: kirish muddati tugagan. Xabardagi havolani qayta oching",

  city_andijan: 'Andijon',
  city_bukhara: 'Buxoro',
  city_guliston: 'Guliston',
  city_jizzakh: 'Jizzax',
  city_karshi: 'Qarshi',
  city_navoi: 'Navoiy',
  city_namangan: 'Namangan',
  city_nukus: 'Nukus',
  city_samarkand: 'Samarqand',
  city_tashkent: 'Toshkent',
  city_termez: 'Termiz',
  city_urgench: 'Urganch',
  city_fergana: 'Farg\'ona',

  // Option values moved to locales/opt/*.js
}
